import { ButtonBaseProps } from '@material-ui/core/ButtonBase'

const buttonBase: ButtonBaseProps = {
  disableRipple: true,
  disableTouchRipple: true,
}

export default buttonBase
